export function Input(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...props}
      style={{
        width: '100%',
        padding: '12px 16px',
        fontSize: 13,
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        color: 'var(--text)',
        outline: 'none',
        ...props.style,
      }}
    />
  );
}

export function Textarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      {...props}
      style={{
        width: '100%',
        padding: '12px 16px',
        fontSize: 13,
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        color: 'var(--text)',
        outline: 'none',
        minHeight: 96,
        resize: 'vertical',
        fontFamily: 'inherit',
        ...props.style,
      }}
    />
  );
}

export function Select(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      {...props}
      style={{
        width: '100%',
        padding: '12px 16px',
        fontSize: 13,
        background: 'var(--bg2)',
        border: '1px solid var(--border)',
        borderRadius: 8,
        color: 'var(--text)',
        outline: 'none',
        ...props.style,
      }}
    />
  );
}
